/**
 * DesignCenter Product
 */
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const getProductQuery = gql`
  query GetProduct($id: Int!) {
    product(id: $id) {
      id
      name
      obj
      mtl
      label
      active
      code
      shortDescription: short_description
      categoryId: category_id
      hasPredyed: has_predyed
      bumpMap: bump_map
      branding
      predyedlabel
      predyed2label
      defaultpredyed2
      hasModal: has_modal
      modalText: modal_text
      modalLinkText: modal_link_text
      glb
      glbEnabled: glb_enabled
      extraMaterials: extra_materials
      flatlock_glb
      bibraceWhite_glb: bib_brace_white_glb
      bibraceNormal_glb: bib_brace_normal_glb
      bibraceBlack_glb: bib_brace_black_glb
      bindingWhite_glb: binding_white_glb
      bindingBlack_glb: binding_black_glb
      branding_glb_png
      branding2_glb_png
      isCustom: design_center
      guideline
      flatlock
      mpn
      binding {
        white
        black
      }
      zipperName: zipper_name
      zipperHidden: zipper_hidden
      zipper {
        white
        black
      }
      zipper2Name: zipper2_name
      zipper2Hidden: zipper2_hidden
      zipper2 {
        white
        black
      }
      bibBrace {
        white
        black
      }
      bibBraceFullprint: bibrace_fullprint
    }
  }
`

export const getVariantsFromProduct = gql`
  query getVariants($id: Int!) {
    getVariants(id: $id) {
      id: short_id
      name
      icon
      default: is_default
      obj
      mtl
      glb
      bibraceWhiteSVG: bibrace_white_svg
      bibraceWhiteGlbSVG: bibrace_white_glb_svg
      bibraceFullPrint: bibrace_fullprint
      branding
      branding_glb
      branding2_glb
    }
  }
`

export const addTeamStoreItemMutation = graphql(
  gql`
    mutation AddTeamStoreItem(
      $teamStoreItem: TeamStoreItem!
      $teamStoreId: String!
    ) {
      addTeamStoreItem(
        teamStoreItem: $teamStoreItem
        teamStoreId: $teamStoreId
      ) {
        message
      }
    }
  `,
  { name: 'addItemToStore' }
)

export const getDesignQuery = gql`
  query getDesign($designId: String!) {
    designData: sharedDesignShortId(designId: $designId) {
      id
      name
      shortId: short_id
      predyedName: predyed_name
      predyed2Name: predyed2_name
      flatlockColor: flatlock
      flatlockCode: flatlock_code
      bindingColor: binding_color
      bibBraceColor: bib_brace_color
      zipperColor: zipper_color
      zipper2Color: zipper2_color
      canEdit: can_edit
      proDesign: pro_design
      proCertified: pro_certified
      outputSvg: output_svg
      shared
      image
      createdAt: created_at
      code
      highResolution: high_resolution
      colors {
        id
        color
        image
      }
      product {
        id
        code
        name
        obj
        mtl
        label
        active
        branding
        guideline
        predyedlabel
        predyed2label
        discontinued
        shortDescription: short_description
        sizeTag: size_tag
        categoryId: category_id
        hideFitStyles: hide_fit_styles
        youthCombined: youth_combined
        hasPredyed: has_predyed
        bumpMap: bump_map
        flatlock
        mpn
        twoPieces: two_pieces
        glb
        glbEnabled: glb_enabled
        extraMaterials: extra_materials
        flatlock_glb
        bibraceWhite_glb: bib_brace_white_glb
        bibraceNormal_glb: bib_brace_normal_glb
        bibraceBlack_glb: bib_brace_black_glb
        bindingWhite_glb: binding_white_glb
        bindingBlack_glb: binding_black_glb
        branding_glb_png
        branding2_glb_png
        binding {
          white
          black
        }
        zipperName: zipper_name
        zipperHidden: zipper_hidden
        zipper {
          white
          black
        }
        zipper2Name: zipper2_name
        zipper2Hidden: zipper2_hidden
        zipper2 {
          white
          black
        }
        bibBrace {
          white
          black
        }
        bibBraceFullprint: bibrace_fullprint
        genders {
          id
          name: gender
        }
        fitStyles {
          id
          info
          name: description
        }
        sizeRange: size_range {
          id
          name
          isYouth: is_youth
        }
        priceRange {
          quantity
          price
          abbreviation
          shortName: short_name
        }
      }
      styleId: style_id
      style {
        id
        name
        image
        width
        height
        brandingPng: branding_png
        brandingPngGlb: branding_variant_glb
      }
      canvas
      flatlock
    }
  }
`

export const getColorsQuery = gql`
  query GetColors {
    colorsResult: getColors {
      colors
      stitchingColors: stitching_colors
    }
  }
`

export const requestColorChartMutation = gql`
  mutation RequestColorChart($userInfo: UserInfoInput) {
    requestColorChart(userInfo: $userInfo) {
      message
    }
  }
`

export const getDesignLabInfo = gql`
  query getDesignLabInfo {
    designInfo: getDesignLabInfo(onlyData: false) {
      deliveryDays: delivery_days
      tutorialPlaylist: tutorial_playlist
      workingHours {
        start
        end
        open
        timeZone
      }
    }
  }
`

export const getUserInfoQuery = gql`
  query getUserInfo {
    profileData: getUserProfile {
      userProfile {
        id
        userId: id
        managerName: account_manager_name
        account_manager
        sales_rep
        country_code
      }
      reseller {
        id
        status
        comission
      }
    }
  }
`

export const getProAssist = gql`
  query proAssistData {
    proAssistData: getProAssist {
      proAssistId: short_id
      user {
        id
      }
    }
  }
`

export const getProTicket = graphql(
  gql`
    mutation newProAssist {
      newProAssist {
        ticket: short_id
        user {
          id
        }
      }
    }
  `,
  { name: 'getProTicketAction' }
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/DesignCenterEnhanced/data.ts